<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid >
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12">
							<v-toolbar dark color="success">
								<v-toolbar-title>Confirming</v-toolbar-title>
							</v-toolbar>
							<v-card-text class="py-5">
								Confirming account, please wait.
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import analysisApi from "../analysisApi";

export default {
	data() {
		return {};
	},
	mounted() {
		analysisApi.confirm(this.$route.params.token)
			.then(() => {
				this.$router.push({ name: "login" });
			})
			.catch((e) => {
				this.showError(e);
			});
	},
};
</script>
